import React from "react";
import { useTranslation } from "react-i18next";
import { SelectableItem } from "../../../../../common/components/selectable-item/SelectableItem";
import styles from "./select-payment-type.module.scss";

interface SelectPaymentTypeProps {
	onSelectSingle: () => void;
	onSelectBulk: () => void;
	showBulk?: boolean;
}

const SinglePaymentIcon: React.FC = () => (
	<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<path
			d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6Z"
			stroke="var(--app-primary-text)"
			strokeWidth="1.6"
			strokeLinejoin="round"
		/>
		<path d="M14 2v6h6M8 13h8M8 17h5" stroke="var(--app-primary-text)" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

const BulkPaymentIcon: React.FC = () => (
	<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<rect x="8" y="8" width="12" height="12" rx="2" stroke="var(--app-primary-text)" strokeWidth="1.6" />
		<path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" stroke="var(--app-primary-text)" strokeWidth="1.6" strokeLinecap="round" />
	</svg>
);

/**
 * Entry chooser for Buy Electricity: Single vs Bulk payment (per Figma).
 * Shown for plain "Buy Electricity" entries; deep-links skip straight to single.
 */
export const SelectPaymentType: React.FC<SelectPaymentTypeProps> = ({ onSelectSingle, onSelectBulk, showBulk = true }) => {
	const { t } = useTranslation();
	return (
		<div className={styles.container}>
			<div className={styles.card}>
				<p className={styles.cardLabel}>{t("buyElectricity.bulk.selectPaymentType")}</p>
				<SelectableItem
					leftIcon={<SinglePaymentIcon />}
					title={t("buyElectricity.bulk.singlePayment")}
					onClick={onSelectSingle}
					hideBottomBorder={!showBulk}
				/>
				{showBulk && (
					<SelectableItem
						leftIcon={<BulkPaymentIcon />}
						title={t("buyElectricity.bulk.bulkPayment")}
						onClick={onSelectBulk}
						hideBottomBorder
					/>
				)}
			</div>
		</div>
	);
};

export default SelectPaymentType;
